import { cn } from "../../lib/utils";
type ImageType = {
  src: string;
  alt?: string;
  title?: string;
  className?: string;
  height?: string;
  width?: string;
};
export const Image = ({
  src,
  alt = "",
  className = "",
  title = "",
  height,
  width,
}: ImageType) => {
  return (
    <img
      src={src}
      height={height}
      width={width}
      alt={alt}
      title={title}
      className={cn(className)}
    />
  );
};
